import { NavItem } from '@/component/Navigation/types';
import { Icon } from '@/icon/Icon';
import {
  cartFullPath,
  catalogsFullPath,
  ordersFullPath,
  recommendationsFullPath,
  searchPartsFullPath,
  shoppinglistsFullPath,
} from '../pathDefinitions';
import { RecommendationsNavIcon } from './recommendation/components/RecommendationIcons';

export const ecomNavItems: NavItem[] = [
  {
    to: searchPartsFullPath,
    icon: <Icon name="parts" size="small" />,
    label: ({ ecom }) => ecom.sidebar.search,
  },
  {
    to: catalogsFullPath,
    icon: <Icon name="book" size="small" />,
    label: ({ ecom }) => ecom.sidebar.catalogs,
    access: (permissions) => permissions.includes('ecom.catalog:r'),
  },
  {
    to: recommendationsFullPath,
    icon: <RecommendationsNavIcon />,
    label: ({ ecom }) => ecom.sidebar.recommendations,
    access: (permissions) => permissions.includes('ecom.reco:r'),
  },
  {
    to: shoppinglistsFullPath,
    icon: <Icon name="shopping_lists" size="small" />,
    label: ({ ecom }) => ecom.sidebar.shoppinglists,
    access: (permissions) => permissions.includes('ecom.order:r'),
  },
  {
    to: ordersFullPath,
    icon: <Icon name="orders" size="small" />,
    label: ({ ecom }) => ecom.sidebar.order,
    access: (permissions) => permissions.includes('ecom.order:r'),
  },
  {
    to: cartFullPath,
    icon: <Icon name="shopping_cart" size="small" />,
    label: ({ ecom }) => ecom.sidebar.cart,
    access: (permissions) => permissions.includes('ecom.order:w'),
  },
];
